<template>
  <div class="hero-text-con px-6 py-16">
    <div
      v-for="(row, i) in text"
      :id="'row#' + i"
      :key="i"
      class="hero-text-row"
      :class="isAnimated ? '' : 'hero-no-animation'"
    >
      {{ row }}
    </div>
    <div id="firstRow" class="hero-text-row">{{ text }}</div>
    <!--    <div id="secondRow" class="hero-text-row">potkává byznys </div>-->
    <!--    <div id="thirdRow" class="hero-text-row">s kreativitou</div>-->
  </div>
</template>

<script>
import gsap from "gsap";
import TextPlugin from "gsap/TextPlugin";
export default {
  name: "HeroText",
  props: {
    isAnimated: {
      type: Boolean,
      default: true,
    },
    text: {
      type: Array,
    },
    width: {
      type: Number,
    },
  },
  data() {
    return {
      screenWidth: typeof window !== "undefined" ? window.innerWidth : 0,
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    if (this.isAnimated) {
      let ratio = 1;
      if (this.screenWidth < 1024) {
        ratio = 0.83;
      }
      if (this.screenWidth < 480) {
        ratio = 0.66;
      }
      gsap.registerPlugin(TextPlugin);
      gsap
        .timeline()
        .to("#firstRow", { duration: 0, delay: 1, visibility: "visible" })
        .to("#firstRow", { duration: 0.8, width: this.width * ratio });
      // .to('#secondRow', {duration: 0,  visibility: 'visible'})
      // .to('#secondRow', {duration: 0.8, width: 350})
      // .to('#thirdRow', {duration: 0, visibility: 'visible'})
      // .to('#thirdRow', {duration: 0.8, width: 285});
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth =
        window.innerWidth || document.documentElement.clientWidth;

      this.animateText();
    },
    animateText() {
      let ratio = 1;
      if (this.screenWidth < 1024) {
        ratio = 0.83;
      }

      if (this.isAnimated) {
        let ratio = 1;
        if (this.screenWidth < 1024) {
          ratio = 0.83;
        }
        if (this.screenWidth < 480) {
          ratio = 0.66;
        }
        gsap.registerPlugin(TextPlugin);
        gsap
          .timeline()
          .to("#firstRow", { duration: 0, delay: 1, visibility: "visible" })
          .to("#firstRow", { duration: 0.8, width: this.width * ratio });
        // .to('#secondRow', {duration: 0,  visibility: 'visible'})
        // .to('#secondRow', {duration: 0.8, width: 350})
        // .to('#thirdRow', {duration: 0, visibility: 'visible'})
        // .to('#thirdRow', {duration: 0.8, width: 285});
      }
    },
  },
};
</script>

<style scoped>
.hero-text-con {
  position: absolute;
  /* left: 10%; */
  bottom: 20%;
}
.hero-text-row {
  visibility: hidden;
  padding: 0px 16px;
  font-size: 48px;
  color: #ffffff;
  min-height: 72px;
  width: 0;
  background: #1a1a1a;
  font-family: Roboto;
  font-weight: 300;
  white-space: nowrap;
  overflow: hidden;

  @media (max-width: 1024px) {
    font-size: 40px !important;
    //padding: 0 8px;
    padding: 16px;
    min-height: 60px;
    /*
        font-style: normal;
        font-weight: 300;
        line-height: 40px;
        */
  }
  @media (max-width: 480px) {
    font-size: 32px !important;
    max-width: 350px;
    white-space: wrap;
    //padding: 0 8px;
    padding: 12px;
    min-height: 52px;
    /*
            font-style: normal;
            font-weight: 300;
            line-height: 40px;
            */
  }
}

.hero-no-animation {
  visibility: visible;
  white-space: nowrap;
}
</style>
